export const round10 = (value: number): number => {
  return Math.round(value * 10) / 10;
};

export const round100 = (value: number): number => {
  return Math.round(value * 100) / 100;
};

export const calculateDiff = (currentValue: number, comparisonValue?: number) => {
  return comparisonValue !== undefined ? round10(currentValue - comparisonValue) : 0;
};
